const isObjectNotEmpty = objectValue => {
  return objectValue && typeof objectValue === 'object' && Object.keys(objectValue).length > 0;
};

module.exports = isObjectNotEmpty;
